import React, { useState } from "react";
import { signInWithEmailAndPassword, sendPasswordResetEmail } from "firebase/auth";
import { auth } from "./firebase";

export default function Login({ onLogin }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  async function handleLogin(e) {
    e.preventDefault();
    setError("");

    try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      onLogin(userCredential.user);

    } catch (err) {
      console.error("LOGIN ERROR →", err.code);

      if (err.code === "auth/user-not-found") {
        setError("❌ Ingen bruger med denne email.");
      } else if (err.code === "auth/wrong-password") {
        setError("❌ Forkert adgangskode.");
      } else if (err.code === "auth/invalid-email") {
        setError("❌ Email-format er ugyldigt.");
      } else {
        setError("🚫 Kunne ikke logge ind. Prøv igen.");
      }
    }
  }
  async function handleResetPassword() {
  if (!email) {
    setError("Indtast din email for at nulstille adgangskoden.");
    return;
  }

  try {
    await sendPasswordResetEmail(auth, email);
    setError("📨 Der er sendt en mail med instruktioner til nulstilling.");
  } catch (err) {
    console.error("RESET ERROR →", err.code);

    if (err.code === "auth/user-not-found") {
      setError("❌ Ingen bruger med denne email.");
    } else {
      setError("🚫 Kunne ikke sende nulstillingsmail.");
    }
  }
}

  return (
	<div
      style={{
        position: "fixed",
        inset: 0,
        backgroundImage: 'url("https://bornholm-golf.dk/derby/static/startbillede.jpg")',
        backgroundSize: "cover",
        backgroundPosition: "center",
        display: "flex",
        justifyContent: "center",
		alignItems: "center",
        color: "#fff",
        textShadow: "0 2px 6px rgba(0,0,0,0.6)",
        zIndex: 9999
      }}
    >
	<div
        style={{
          backgroundColor: "rgba(219, 245, 215, 0.80)",
          border: "3px solid #7AAD08",
          borderRadius: "16px",
          padding: "40px 60px",
          textAlign: "center",
          maxWidth: "1000px",
          color: "#2e3d2f",
          boxShadow: "0 8px 20px rgba(0,0,0,0.55)"
        }}
      >

      <h2>🏆 DERBY - Hestevæddeløb på Nordskovens Galopbane med præmier og spænding 🏆<br/>
	  <br/> 📤 Login for at spille DERBY</h2>

      <form onSubmit={handleLogin}>
        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          style={{ fontSize: "20px", margin: "10px" }}
        />
        <br />
        <input
          type="password"
          placeholder="Adgangskode"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          style={{ fontSize: "20px", margin: "10px" }}
        />
        <br />

        <button type="submit" style={{
          fontSize: "20px",
          backgroundColor: "#",
          color: "#222",
          padding: "6px 24px",
          borderRadius: "8px",
          border: "2px solid #2e7d32",
          cursor: "pointer",
          boxShadow: "0 4px 10px rgba(0,0,0,0.3)"
        }}
		onMouseOver={(e) => (e.target.style.backgroundColor = "#a5d6a7")}
        onMouseOut={(e) => (e.target.style.backgroundColor = "#c8e6c9")}
      >
          🐴 Log ind 🍀
        </button>
      </form>
	  
	  <button
  type="button"
  onClick={handleResetPassword}
  style={{
    marginTop: "10px",
    fontSize: "18px",
    background: "none",
    color: "#0077cc",
    textDecoration: "underline",
    border: "none",
    cursor: "pointer"
  }}
>
  Glemt adgangskode?
</button>

	  
{error && (
  <p style={{ color: "red", marginTop: "10px", fontWeight: "bold" }}>
    {error}
  </p>
)}
      <h2 style={{ marginTop: "10px" }}><br/>
        Har du ikke en spilkonto til DERBY?  <br/><button onClick={() => onLogin("register")} style={{
          fontSize: "20px",
          backgroundColor: "#",
          color: "#222",
          padding: "6px 20px",
          borderRadius: "6px",
          border: "2px solid #2e7d32",
          cursor: "pointer",
          boxShadow: "0 4px 10px rgba(0,0,0,0.3)"
        }}
		onMouseOver={(e) => (e.target.style.backgroundColor = "#a5d6a7")}
        onMouseOut={(e) => (e.target.style.backgroundColor = "#c8e6c9")}
      >
          Opret spilkonto 🏇🏼
        </button>
      </h2>
	<h3>Da jeg har brugt mange timer på at udvikle dette spil, vil jeg i første omgang gerne vide hvem der logger sig på. 
	  Opret derfor en spilkonto, så kan jeg se at du spiller. Det er stadig GRATIS.<br/>Brug evt. denne testkonto: test@derby.dk - Adgangskode: Galop864</h3>
	   </div>
	   </div>
  )
}